import React, {
  type FC,
  type PropsWithChildren,
  type CSSProperties,
} from 'react'
import clsx from 'clsx'
import {CrossIcon} from '../Icons'
import type {StatusModalType} from '../types'
import styles from './Modal.scss'

export type ModalProps = PropsWithChildren & {
  onClose?: () => void;
  style?: CSSProperties
  classes?: {
    modal?: string;
    cross?: string;
  }
  status: StatusModalType
};

export const Modal: FC<ModalProps> = (props) => {
  const {children, classes, onClose, style} = props;

  return (
    <div className={styles.modalsContainerBackground}>
      <div className={clsx(styles.modal, classes?.modal )} style={style}>
        {onClose && (
          <span className={clsx(styles.cross, classes?.cross)} onClick={onClose}>
            <CrossIcon />
          </span>
        )}
        {children}
      </div>
    </div>
  )
}
